













































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Contract as IContract } from "@/api/models/contract";
import { Act as IAct } from "@/api/models/act";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { ActEdit as IActEdit } from "@/api/models/act-edit";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import LearningResourceTable from "@/components/learning-resource/LearningResourceTable.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { isRoot } from "@/plugins/roles";
import { LearningResourceInfo as ILearningResourceInfo } from "@/api/models/learning-resource-info";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";

/**
 * This form in contract page
 */
@Component({
  components: {
    DeleteMaterialModal,
    DocumentNumberInput,
    CustomButton,
    CSingleSelect,
    LearningResourceTable,
    CustomDatepicker
  }
})
export default class ActForm extends Vue {
  @Prop() contract!: IContract;
  @Prop() act?: IAct;
  @Prop() companyId?: string;
  learningResources: Array<ILearningResourceInfo> | undefined = this.act
    ? this.act.learningResources
    : this.contract.learningResources;
  checkedResources: Array<ILearningResourceInfo> | undefined = [];
  number!: string | undefined;
  responsibleList!: IEmployeesList2;
  responsibleId!: string | undefined;
  formedAt!: Date | undefined;
  signedAt!: Date | undefined;
  changed: boolean = false;
  price!: number;
  employees!: EmployeesListClass;
  isSavingProcess: boolean = false;
  showDeleteModal: boolean = false;

  data() {
    return {
      number: undefined,
      price: undefined,
      responsibleList: undefined,
      responsibleId: undefined,
      formedAt: undefined,
      signedAt: undefined,
      employees: undefined
    };
  }

  getResponsibleList() {
    let params: EmployeeListParams = {
      id: this.companyId ? this.companyId : this.contract.companyId,
      roles: ["document_manager"],
      limit: 900
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.responsibleList = res.data;
      if (this.responsibleList.employees.length && !this.act) {
        if (this.root || this.companyOwner) {
          this.responsibleId = this.responsibleList.employees[0].id;
        } else {
          this.responsibleId = this.currentEmployee.id;
        }
      }
    });
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get currentEmployee() {
    return this.$store.getters.userIsEmployee;
  }

  returnThisDay() {
    this.formedAt = new Date();
  }

  getCheckedResources(el: any) {
    this.checkedResources = el;
  }

  getDocumentsManager() {
    if (this.companyId) {
      this.employees = new EmployeesListClass(
        {
          id: this.companyId ? this.companyId : this.contract.companyId,
          roles: ["document_manager"]
        },
        this.companyId ? this.companyId : undefined,
        this.responsibleId ? this.responsibleId : undefined
      );
    }
  }

  saveAct() {
    this.isSavingProcess = true;
    if (!this.act) {
      if (this.number) {
        let params: IActEdit = {
          contractId: this.contract.id,
          number: this.number,
          learningResources: this.checkedResources,
          responsibleId: this.responsibleId!,
          price: this.$converter.setPrice(this.price),
          formedAt: this.formedAt,
          signedAt: this.signedAt,
          fileIds: []
        };
        api.ActApi.create(params)
          .then(async () => {
            await nextSequence();
            await this.$emit("updateAct");
            await this.$destroy();
          })
          .catch(
            (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
              if (error.response?.data?.message) {
                this.$bvToast.toast(error.response.data.message, {
                  variant: "danger",
                  title: `${this.$tc(this.$translate.Error)}`
                });
              } else {
                this.$bvToast.toast(
                  `${this.$tc(this.$translate.SorrySomethingWentWrong)}`,
                  {
                    variant: "danger",
                    title: `${this.$tc(this.$translate.Error)}`
                  }
                );
              }
            }
          )
          .finally(() => {
            this.isSavingProcess = false;
          });
      }
    } else {
      this.isSavingProcess = true;
      if (this.number) {
        let params: IActEdit = {
          contractId: this.act.contractId,
          number: this.number,
          learningResources: this.checkedResources,
          responsibleId: this.responsibleId!,
          price: this.$converter.setPrice(this.price),
          formedAt: this.formedAt,
          signedAt: this.signedAt,
          fileIds: this.act.files?.length
            ? this.act.files.map((el: any) => el.id)
            : []
        };

        api.ActApi.edit(this.act.id, params)
          .then(async (res: { data: IAct }) => {
            await nextSequence();
            await this.$router.push({
              name: "act",
              params: { actId: res.data.id }
            });
          })
          .catch(
            (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
              if (error.response?.data?.message) {
                this.$bvToast.toast(error.response.data.message, {
                  variant: "danger",
                  title: `${this.$tc(this.$translate.Error)}`
                });
              } else {
                this.$bvToast.toast(
                  `${this.$tc(this.$translate.SorrySomethingWentWrong)}`,
                  {
                    variant: "danger",
                    title: `${this.$tc(this.$translate.Error)}`
                  }
                );
              }
            }
          )
          .finally(() => {
            this.isSavingProcess = false;
          });
      }
    }
  }

  showDeleteForm() {
    this.showDeleteModal = true;
  }

  hideDeleteModal() {
    this.showDeleteModal = false;
  }

  deleteAct() {
    this.isSavingProcess = true;
    this.showDeleteModal = false;
    if (this.act) {
      api.ActApi._delete(this.act.id)
        .then(() => {
          this.$router.push({ name: "acts" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.hideDeleteModal();
        });
    }
  }

  @Watch("checkedResources")
  checkCheckedResource() {
    if (!!this.act && !this.changed) {
      this.price = this.$converter.getPrice(this.act.price);
      this.changed = true;
      return;
    }
    if (this.checkedResources && this.checkedResources.length > 0) {
      let price: number;
      price = this.checkedResources
        .map(el => el.amount)
        .reduce((acc, item) => {
          return acc + item;
        }, 0);
      this.price = this.$converter.getPrice(price);
      this.changed = true;
    } else {
      this.price = 0;
      this.changed = true;
    }
  }

  created() {
    this.getResponsibleList();
    this.getDocumentsManager();
    if (this.act) {
      this.responsibleId = this.act.responsibleId;
      this.checkedResources = this.act.learningResources;
      this.price = this.act.price;
      this.number = this.act.number;
      this.formedAt = this.act.formedAt;
      this.signedAt = this.act.signedAt;
    }
  }
}
